import { Reveal } from "./Reveal";

// ---------------------------------------------------------------------------
// COMPARE — "Tu semana, antes y después." Table, no cards.
// Each row staggers in on scroll.
// ---------------------------------------------------------------------------

const compare = [
  {
    k: "Una consulta a la noche",
    before: "Se contesta al día siguiente. Ya compró en otro lado.",
    after: "El Agente IA responde al toque y la agenda.",
  },
  {
    k: "Un presupuesto enviado",
    before: "Queda esperando. Nadie le hace seguimiento.",
    after: "Seguimiento automático a los 2, 5, 10 y 20 días.",
  },
  {
    k: "Un cliente del año pasado",
    before: "No sabe nada de vos hace 12 meses.",
    after: "El sistema le avisa que toca volver a contratarte.",
  },
  {
    k: "Tu ficha de Google",
    before: "Aparecés séptimo, con 9 reseñas.",
    after: "Reseñas automáticas después de cada trabajo.",
  },
  {
    k: "Los lunes",
    before: "No sabés cuánta plata tenés en la calle.",
    after: "Te llega el reporte con todo, por WhatsApp y mail.",
  },
  {
    k: "La tecnología",
    before: "Tenés que aprender marketing y herramientas.",
    after: "Lo armamos nosotros. Vos apretás dos botones.",
  },
];

export function HomeCompare() {
  return (
    <section
      data-screen-label="Antes y después"
      className="mx-auto px-6"
      style={{
        maxWidth: 1240,
        paddingTop: "clamp(80px,10vw,128px)",
        paddingBottom: "clamp(80px,10vw,128px)",
      }}
    >
      <Reveal>
        <div
          className="font-mono text-[13px] text-[#A78BFA]"
          style={{ letterSpacing: "0.08em" }}
        >
          04 — LA DIFERENCIA
        </div>
        <h2
          className="mt-5 text-[#EEEDF2] font-medium"
          style={{
            fontSize: "clamp(36px,4.8vw,64px)",
            lineHeight: 1.02,
            letterSpacing: "-0.025em",
            textWrap: "balance" as never,
          }}
        >
          Tu semana, antes y después.
        </h2>
      </Reveal>

      <div className="mt-12 border border-[#221F2A] rounded-2xl overflow-hidden">
        <div
          className="grid bg-[#13111A] border-b border-[#221F2A] font-mono text-[12px]"
          style={{
            gridTemplateColumns:
              "minmax(160px,1fr) minmax(0,1.3fr) minmax(0,1.3fr)",
            letterSpacing: "0.06em",
          }}
        >
          <div className="px-[22px] py-4 text-[#6E6A7A]">SITUACIÓN</div>
          <div className="px-[22px] py-4 text-[#9C98A6] border-l border-[#221F2A]">
            HOY
          </div>
          <div className="px-[22px] py-4 text-[#A78BFA] border-l border-[#221F2A]">
            CON CRECELOCAL
          </div>
        </div>
        {compare.map((c, i) => (
          <Reveal key={c.k} delay={i * 0.06}>
            <div
              className="grid border-b border-[#1C1924] last:border-0 hover:bg-[#110F17] transition-colors"
              style={{
                gridTemplateColumns:
                  "minmax(160px,1fr) minmax(0,1.3fr) minmax(0,1.3fr)",
              }}
            >
              <div className="px-[22px] py-5 font-semibold text-[15px] text-[#EEEDF2]">
                {c.k}
              </div>
              <div
                className="px-[22px] py-5 text-[15px] leading-[1.45] border-l border-[#1C1924] text-[#827E8E]"
                style={{
                  textDecoration: "line-through",
                  textDecorationColor: "#433C52",
                }}
              >
                {c.before}
              </div>
              <div className="px-[22px] py-5 text-[15px] leading-[1.45] border-l border-[#1C1924] text-[#EEEDF2]">
                {c.after}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
